const ADD_SWIGGY_MONEY_PREFIX = "add_swiggy_money";

export const ADD_SWIGGY_MONEY_TEST_IDS = {
    CONTAINER: `${ADD_SWIGGY_MONEY_PREFIX}_container`,
    PROCEED_BTN: `${ADD_SWIGGY_MONEY_PREFIX}_proceed_btn`,
    AMOUNT_SELECTION_CONTAINER: `${ADD_SWIGGY_MONEY_PREFIX}_amt_selection_container`,
    AMOUNT_SUGGESION_BOX: `${ADD_SWIGGY_MONEY_PREFIX}_amt_suggestion_box`,
    AMOUNT_SUGGESION_BOX_SELECTED: `${ADD_SWIGGY_MONEY_PREFIX}_amt_suggestion_box_selected`,
    AMOUNT_SELECTION_INPUT_BOX: `${ADD_SWIGGY_MONEY_PREFIX}_amt_input`,
    AMOUNT_SELECTION_INPUT_ERROR: `${ADD_SWIGGY_MONEY_PREFIX}_amt_error`,
};
